// React and Icons
import React from 'react'
import { MdOutlineAddCircleOutline } from 'react-icons/md'

// Components
import LinkButton from '../../components/Custom/Buttons/LinkButton'
import PageHeader from '../../components/Custom/PageHeader/PageHeader'
import Patterns from '../../components/Patterns'

// Utils
import useUserStore from '../../utils/state/useUserStore'

const Pattern = () => {
  const userPermissions = useUserStore((state) => state.user) || []

  return (
    <div>
      <PageHeader>
        <div className='flex gap-2 items-center justify-between w-full'>
          <div className='flex gap-2 items-center font-medium'>
            <h1 className='text-2xl'>Pattern</h1>
          </div>
          {userPermissions?.includes('pattern:create') ? (
            <LinkButton
              icon={<MdOutlineAddCircleOutline className='text-xl' />}
              to={'/pattern/add'}
              label={'Add Pattern'}
            />
          ) : null}
        </div>
      </PageHeader>
      <Patterns userPermissions={userPermissions} />
    </div>
  )
}

export default Pattern
